// Libs
import classNames from 'classnames/bind';
import { Box, Tabs, TabsProps } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BaseVerticalTab.module.scss';

type Props = TabsProps;

const cx = classNames.bind(styles);

const BaseVerticalTab = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='verticalTabComponent' className={cx('baseVerticalTab')}>
      <Tabs {...props} TabIndicatorProps={{ className: cx('tabIndicator') }} orientation='vertical'>
        {props.children}
      </Tabs>
    </Box>
  );
};

export default BaseVerticalTab;
